var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9999 20.1667C16.0625 20.1667 20.1666 16.0626 20.1666 11C20.1666 5.9374 16.0625 1.83334 10.9999 1.83334C5.93731 1.83334 1.83325 5.9374 1.83325 11C1.83325 16.0626 5.93731 20.1667 10.9999 20.1667Z",
    fill: "#25314C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9724 11L14.2356 8.73584C14.3571 8.60551 14.4232 8.43313 14.4201 8.25502C14.4169 8.07691 14.3448 7.90698 14.2188 7.78102C14.0928 7.65505 13.9229 7.5829 13.7448 7.57976C13.5667 7.57662 13.3943 7.64273 13.264 7.76417L10.9998 10.0274L8.73565 7.76417C8.60532 7.64273 8.43295 7.57662 8.25484 7.57976C8.07673 7.5829 7.90679 7.65505 7.78083 7.78102C7.65487 7.90698 7.58271 8.07691 7.57957 8.25502C7.57643 8.43313 7.64254 8.60551 7.76398 8.73584L10.0272 11L7.76398 13.2642C7.69644 13.3271 7.64226 13.403 7.60468 13.4873C7.56711 13.5717 7.5469 13.6627 7.54527 13.755C7.54364 13.8473 7.56063 13.939 7.5952 14.0246C7.62978 14.1102 7.68125 14.188 7.74653 14.2533C7.81181 14.3186 7.88958 14.37 7.97518 14.4046C8.06079 14.4392 8.15248 14.4562 8.24479 14.4545C8.33711 14.4529 8.42814 14.4327 8.51248 14.3951C8.59681 14.3576 8.67271 14.3034 8.73565 14.2358L10.9998 11.9726L13.264 14.2358C13.3943 14.3573 13.5667 14.4234 13.7448 14.4202C13.9229 14.4171 14.0928 14.345 14.2188 14.219C14.3448 14.093 14.4169 13.9231 14.4201 13.745C14.4232 13.5669 14.3571 13.3945 14.2356 13.2642L11.9724 11Z",
    fill: "#25314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a8b014cceb488b7f135908f813e2a44a.svg";
export { ForwardRef as ReactComponent };